/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes =
  {
    TenantApiKeyScopeUnspecified: "TENANT_API_KEY_SCOPE_UNSPECIFIED",
    TenantApiKeyScopeReadJobs: "TENANT_API_KEY_SCOPE_READ_JOBS",
    TenantApiKeyScopeReadLeads: "TENANT_API_KEY_SCOPE_READ_LEADS",
    TenantApiKeyScopeReadWorkflows: "TENANT_API_KEY_SCOPE_READ_WORKFLOWS",
    TenantApiKeyScopeReadAnalytics: "TENANT_API_KEY_SCOPE_READ_ANALYTICS",
    TenantApiKeyScopeReadSettings: "TENANT_API_KEY_SCOPE_READ_SETTINGS",
    TenantApiKeyScopeWriteJobs: "TENANT_API_KEY_SCOPE_WRITE_JOBS",
    TenantApiKeyScopeWriteLeads: "TENANT_API_KEY_SCOPE_WRITE_LEADS",
    TenantApiKeyScopeWriteWorkflows: "TENANT_API_KEY_SCOPE_WRITE_WORKFLOWS",
    TenantApiKeyScopeWriteSettings: "TENANT_API_KEY_SCOPE_WRITE_SETTINGS",
    TenantApiKeyScopeDeleteJobs: "TENANT_API_KEY_SCOPE_DELETE_JOBS",
    TenantApiKeyScopeDeleteLeads: "TENANT_API_KEY_SCOPE_DELETE_LEADS",
    TenantApiKeyScopeDeleteWorkflows: "TENANT_API_KEY_SCOPE_DELETE_WORKFLOWS",
    TenantApiKeyScopeExportData: "TENANT_API_KEY_SCOPE_EXPORT_DATA",
    TenantApiKeyScopeManageKeys: "TENANT_API_KEY_SCOPE_MANAGE_KEYS",
    TenantApiKeyScopeBillingRead: "TENANT_API_KEY_SCOPE_BILLING_READ",
    TenantApiKeyScopeBillingWrite: "TENANT_API_KEY_SCOPE_BILLING_WRITE",
    TenantApiKeyScopeAdmin: "TENANT_API_KEY_SCOPE_ADMIN",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus
      | undefined;
    scopes?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes
      >
      | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    apiKey?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey
      | undefined;
  };

/**
 * Creates a new API key for a tenant with specified permissions
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody =
  {
    keyId?: string | undefined;
    keyValue?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$inboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$Outbound =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status: string;
    scopes?: Array<string> | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysScopes$outboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKeyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKeyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    apiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$Outbound =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    apiKey?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    apiKey: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysApiKey$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    keyId: z.string().optional(),
    keyValue: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$Outbound =
  {
    keyId?: string | undefined;
    keyValue?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody
  > = z.object({
    keyId: z.string().optional(),
    keyValue: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysResponseBody' from JSON`,
  );
}
